import { createFileRoute } from '@tanstack/react-router'
import { AssetsExportPage } from '../../../components/AssetsExportPage'

type ExportSearchParams = {
  format?: string
  entities?: string
}

export const Route = createFileRoute('/$org/data/export')({
  component: DataExport,
  validateSearch: (search: Record<string, unknown>): ExportSearchParams => ({
    format: typeof search.format === 'string' ? search.format : undefined,
    entities: typeof search.entities === 'string' ? search.entities : undefined,
  }),
})

function DataExport() {
  return <AssetsExportPage />
}
